module.exports = __webpack_public_path__ + "static/media/cover-kitchen-exhaust-systems.ce314e7c.jpg";